import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { buyCoins } from '@/assets'
// import useOffsets from '@/hooks/useOffsets'

export const EmptyActivity: React.FC = () => {
  const { t } = useTranslation()
  // const offsets = useOffsets()

  return (
    <BaseView
      flex={1}
      style={
        {
          // paddingTop: `${offsets.top + 20}px`,
          // paddingHorizontal: '12px',
        }
      }
    >
      {/* Title - matching RN version */}
      <BaseText
        fontSize={24}
        fontFamily="semibold"
        color="label.default"
        style={{ marginBottom: 'auto', marginLeft: '13px' }}
      >
        {t('translation:activity', 'Activity')}
      </BaseText>

      {/* Content - matching RN version layout */}
      <BaseView
        align="center"
        style={{
          gap: '40px',
          marginTop: 'auto',
          marginBottom: 'auto',
        }}
      >
        {/* Image - matching RN version size and image */}
        <img
          src={buyCoins}
          alt="Buy coins illustration"
          style={{
            width: '331px',
            height: '331px',
            maxWidth: '90vw',
            maxHeight: '331px',
            objectFit: 'contain',
          }}
        />

        {/* Description - matching RN version */}
        <BaseText
          fontSize={16}
          fontFamily="regular"
          color="label.description"
          textAlign="center"
          style={{
            paddingLeft: '20px',
            paddingRight: '20px',
            lineHeight: '24px',
          }}
        >
          {t(
            'anyTransactionDescription',
            'Your transaction history will appear here once you start using KEM.',
          )}
        </BaseText>
      </BaseView>
    </BaseView>
  )
}
